import { Breadcrumb, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../../../assests/images/settingsBreadCum.svg";
import { ReactComponent as DebitCardIcon } from "../../../../assests/images/requestDebitCard.svg";
import AccountCard from "../../../../components/account-card";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";

export default function DebitCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/settings")}>
              {t("navigation.other", {
                defaultValue: "Other Services",
              })}
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/request")}>
              {t("pages.my_accounts.cardless_cash.request", {
                defaultValue: "Request",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {" "}
              {t("pages.profile.debit_card", {
                defaultValue: "Debit Card",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.profile.debit_card", {
                defaultValue: "Debit Card",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
          <Card className="application-card">
            <AccountCard />
          </Card>
        </div>
        <div className="col-8">
          <Card className="application-card ">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <Card
                  className="settingscard mb-3 "
                  align="center"
                  onClick={() =>
                    navigate("/request/debit-card/request-card")
                  }
                >
                  <div className="my-3">
                    <DebitCardIcon height={40} />{" "}
                  </div>
                  <div className="my-2">
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      {t("pages.settings.request_card", {
                        defaultValue: "Request Card",
                      })}
                    </span>
                  </div>
                  <div>
                    <span
                      className="secondary_txt_color_two"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {t("pages.settings.request_the_debit_card", {
                        defaultValue: "Request the debit card",
                      })}
                    </span>
                  </div>
                </Card>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
